var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class ButtonToggle extends Component {
    constructor() {
        super('ButtonToggle', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.btn-toggle-content').on('click', (event, button) => {
                event.preventDefault();
                button.toggleClass('is-active');
                button.next().toggleClass('is-opened');
            });
            // Wait for all font to be loaded before computing the nav height
            document.fonts.ready.then(() => {
                this.computeHeight();
            });
            $(window).on('resize', () => {
                this.computeHeight();
            });
            this.computeHeight();
            this.success();
        });
    }
    /*
   * Compute the max height of the nav and set it as a CSS variable
   */
    computeHeight() {
        $('.toggleable-content').each((nav) => {
            nav.css('--max-height', `${nav.find('div').height()}px`);
        });
    }
}
